import axios from "axios";
import { Component } from 'react';
import { Alert, Button, Card, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { hasPermission } from '../../utils/usePermission';
import { validateCopyNewRoleForm } from '../../utils/validation';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';
import CommonTableModule from './../CommonTable/CommonTableModule';

export default class RoleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rolesData: [],
      loading: true,
      hasError: false,
      errMsg: "",
      showModal: false,
      newRole: "",
      selectedRowData: null,
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: '',
    };
  }
  componentDidMount() {
    this.fetchRoleData();
  }
  fetchRoleData = async () => {
    this.setState({ loading: true })
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    try {
      // debugger;
      const response = await axios.get('/role', { headers });
      console.log("response?.data?.roles", response?.data);
      this.setState({ rolesData: response?.data?.roles });
      setTimeout(() => {
        this.setState({ loading: false });
      }, 900);
    } catch (error) {
      console.error("Error fetching role:", error);
      let errorMessage = "Failed to load role.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      }
      this.setState({ hasError: true, errMsg: errorMessage, loading: false });
    }
  }

  handleShowModal = (rowData) => {
    this.setState({ showModal: true, selectedRowData: rowData, newRole: "" });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, selectedRowData: null, newRole: "" });
  };

  handleNewRoleChange = (e) => {
    this.setState({ newRole: e.target.value });
  };

  handleSaveRole = async () => {
    // debugger
    const { newRole, selectedRowData } = this.state;
    console.log("Copied role for:", selectedRowData);
    const token = localStorage.getItem("token");

    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in." });
      return;
    }
    const headers = { Authorization: `Bearer ${token}` };
    const errors = validateCopyNewRoleForm(
      this.state.newRole
    );
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    const newRolePayload = {
      sourceRoleId: selectedRowData?.id,
      newRoleName: newRole
    }
    try {
      const res = await axios.post('/role/cloneRole', newRolePayload, { headers });
      console.log("New res:", res);
      this.setState({
        toastMessage: res?.data.message,
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
      this.handleCloseModal();
      this.fetchRoleData();
    } catch (error) {
      console.error("Error adding role:", error);
      let errorMessage = "Failed to add role.";

      if (error.response) {
        if (error.response.status === 400) {
          errorMessage = error.response.data.error || "Validation error!";
        } else if (error.response.status === 403) {
          errorMessage = "Access Denied! Admin privileges required.";
        }
      }
      this.setState({
        hasError: true,
        errMsg: errorMessage,
        toastMessage: "Role not created!",
        toastVariant: 'danger',
        color: 'red',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
      }, 900);
    }
  };

  onGiveAuthorization = (data) => {
    if (!data) {
      console.error("No rowData provided!");
      return;
    }
    this.props.history.push({
      pathname: `/authorization/${data.id}`,
      state: { data }
    });
  }
  handleAddRole = () => {
    this.props.history.push('/role-add')
  }
  render() {
    const columns = [
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },

      {
        key: "actions",
        label: "Action",
        render: (value, rowData) => {
          return (
            <>
              {/* {
                rowData?.name !== 'super admin' && ( */}
              <>
                {hasPermission('M1S2B2') && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-edit-${rowData?.id || "default"}`}>Authorization</Tooltip>}
                  >
                    <Button
                      size="sm"
                      variant="outline-info"
                      className="mr-2 info"
                      onClick={() => this.onGiveAuthorization(rowData)}
                    >
                      <i className="fas fa-key"></i>
                    </Button>
                  </OverlayTrigger>
                )}
                {hasPermission('M1S2B3') && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-edit-${rowData?.id || "default"}`}>Copy Role</Tooltip>}
                  >
                    <Button
                      size="sm"
                      variant="outline-info"
                      className="mr-2 info"
                      onClick={() => this.handleShowModal(rowData)}
                    >
                      <i className="fa fa-copy"></i>
                    </Button>
                  </OverlayTrigger>
                )}
              </>
              {/* //   )
            // } */}
            </>
          );
        }

      },
    ];
    return (
      <div className="container-fluid pt-4">

        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M1S2B1') && (
            <div className='add-role'>
              <Button variant="primary" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button" onClick={this.handleAddRole}> <i className="fa fa-plus-circle"></i> Add Role</Button>
            </div>
          )}
          <Card className="mb-3">
            <Card.Header>
              <b>Role List</b>

            </Card.Header>
            <Card.Body>
              {this.state.hasError ? (
                <Alert variant="outline-danger" className="m-3">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <CommonTableModule columns={columns} data={this.state.rolesData} />
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Copy Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formNewRole">
                <Form.Label className='required'>New Role Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter new role name"
                  value={this.state.newRole}
                  onChange={this.handleNewRoleChange}
                />
              </Form.Group>
              <span className="login-error">
                {this.state.errors.newRole && <small className="text-danger">{this.state.errors.newRole}</small>}
              </span>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleCloseModal}>
              Cancel
            </Button>
            <Button variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary" onClick={this.handleSaveRole}>
              Save Role
            </Button>
          </Modal.Footer>
        </Modal>

      </div>
    )
  }
}
